<template>
  <div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'cy-main'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/comm/views/Layout/components/cy-main.vue